import React from 'react'

function Header() {
  return (
    <div className='text-center text-3xl py-6 text-white font-bold '>
        WEATHER APP
    </div>
  )
}

export default Header